import React from 'react';
import {DropdownV2, Flex, Text, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import texts from '../texts';
import {getTopDialogZindex} from '../../../_shared/GWTBridge/invoke/priModalDlg';
import styles from '../styles/WidgetHeader.module.scss';
import {Tooltip} from '../../../components/Common/Tooltip/index';
import {createDataTestId} from '../../../utils/dataTestId';

export const DropdownMenu = ({
    open,
    deleteWidget,
    setOpen,
    setIsSettingsPanelOpen
}: {
    open: boolean;
    deleteWidget: () => void;
    setOpen: (boolean) => void;
    setIsSettingsPanelOpen: (boolean) => void;
}) => {
    const handleClose = () => {
        setOpen(false);
    };

    const onOpenSettingsPanel = () => {
        setIsSettingsPanelOpen(true);
        handleClose();
    };

    const onDelete = () => {
        handleClose();
        deleteWidget();
    };
    return (
        <DropdownV2
            isOpen={open}
            width={'contentWidth'}
            onClose={handleClose}
            trigger={
                <Tooltip
                    tooltip={texts.more_actions_tooltip}
                    position="top center"
                    zIndex={getTopDialogZindex()}
                >
                    <Icon
                        {...createDataTestId('TODOWidget-settings-trigger', true)}
                        icon={PriorityIcon.threeDots}
                        iconColor="secondary-500"
                        onClick={() => setOpen(true)}
                        componentClasses={styles.headerIcon}
                    />
                </Tooltip>
            }
        >
            <Flex componentClasses={styles.settingsContainer} direction="column">
                <div className={styles.menuItemWrapper}>
                    <Text
                        skin="label-2"
                        textColor="primary-700"
                        componentClasses={styles.headerMenuItem}
                        onClick={onOpenSettingsPanel}
                    >
                        {texts.setting}
                    </Text>
                </div>
                <div className={styles.separator} />
                <div className={styles.menuItemWrapper}>
                    <Text
                        skin="label-2"
                        textColor="primary-700"
                        componentClasses={styles.headerMenuItem}
                        onClick={onDelete}
                    >
                        {texts.delete}
                    </Text>
                </div>
            </Flex>
        </DropdownV2>
    );
};
